import { orderBy } from 'lodash';
import { FLOW_TYPE } from 'consts';
import { Answer, QuestionGroup, QuestionProps, Questionnaire, RiskChoice, RiskProfile, RiskQuestion } from 'types';

const CHOICE_BOOL = ['Já', 'Nei'];
const CHOICE_INLINE = [...CHOICE_BOOL, 'Engin', 'Góð', 'Lítil', 'Miðlungs', 'Nokkur', 'Rangt', 'Rétt'];

export function IsBoolChoice(choices: RiskChoice[]) {
	return 2 === choices.length && choices.every(c => ~CHOICE_BOOL.indexOf(c.caption));
}

export function IsInline(choices: RiskChoice[]) {
	return choices.length && choices.every(c => ~CHOICE_INLINE.indexOf(c.caption));
}

export function IsDisabled() {
	const wrapper = document.querySelector('.container.page-container');
	if (wrapper) {
		const inputs = wrapper.querySelectorAll('input');
		if (inputs.length) {
			const answers = Array.from(inputs).reduce(setAnswers, {});
			return Object.keys(answers).some(id => false === answers[id]);
		}
	}
	return true;
}

function setAnswers(map: any, input: any) {
	if (map[input.name]) return map;
	switch (input.type) {
		case 'checkbox':
		case 'radio':
			map[input.name] = input.checked;
			return map;
		case 'hidden':
		case 'text':
			map[input.name] = !!input.value.trim();
			return map;
		default:
			return map;
	}
}

export function isRiskLevelAllowed(current?: string, testing?: string) {
	const currentLevel = RiskLevel(current);
	const testingLevel = RiskLevel(testing);
	if (isNaN(currentLevel) || isNaN(testingLevel)) {
		console.error("Can't determinate RiskLevel");
		return false;
	}
	return testingLevel <= currentLevel;
}

function RiskLevel(str = '') {
	return str.charCodeAt(str.length - 1);
}

export function isQuestionVisible(props: QuestionProps, riskq: Answer[]) {
	const { dependencyChoiceIds, dependsOnQuestionId, testId } = props;
	if (null === dependsOnQuestionId) return true;
	return dependencyChoiceIds.some(id => {
		return riskq.find(a => {
			return id === a.choiceId && dependsOnQuestionId === a.questionId && testId === a.testId;
		});
	});
}

export function buildAnswer(testId: number, questionId: number, choiceId: number): Answer {
	return { questionId, choiceId, testId, textValue: null };
}

export function nextBTNLabel(flowType: string, isLastPage: boolean, t: Function) {
	if (isLastPage) return t('submit_btn_label');
	if (FLOW_TYPE.RR_SU === flowType) return t('rr-su_continue');
	return t('continue');
}

export function getDropdownValue(choices: RiskChoice[], answer?: Answer) {
	const index = choices.findIndex(c => c.id === answer?.choiceId);
	return -1 === index ? '' : index;
}

export function hasLabel(recommendedId: number, profileId: number, riskProfile: RiskProfile) {
	return recommendedId === profileId || riskProfile?.id === profileId;
}

export function transformRiskq(riskq: Questionnaire) {
	return { ...riskq, questionGroups: riskq.questionGroups.reduce(transformRiskqReducer, []) };
}

function transformRiskqReducer(acc: QuestionGroup[], group: QuestionGroup) {
	const questions = orderBy(group.questions, 'ordering', 'asc');
	questions.forEach(sortQuestions);
	acc.push({ ...group, questions });
	return acc;
}

function sortQuestions(question: RiskQuestion) {
	question.subQuestions = orderBy(question.subQuestions, 'ordering', 'asc');
	question.choices.sort(sortChoices);
}

function sortChoices(a: RiskChoice, b: RiskChoice) {
	const x = Number(a.ordering);
	const y = Number(b.ordering);
	if (x < y) return -1;
	if (x > y) return 1;
	return 0;
}
